import { FunctionComponent } from 'react';
import { Lottie, LottieTypes } from '@monorepo/react-components';
import { Application } from '@monorepo/types';

import styles from './brand-spinner.module.scss';

interface Props {
  application: Application;
}

export const AppLoadingSpinner: FunctionComponent<Props> = ({
  application,
}) => {
  return (
    <div className={styles['appLoadingSpinner']}>
      <BrandSpinner application={application} />
    </div>
  );
};

export const BrandSpinner: FunctionComponent<Props> = ({ application }) => {
  return (
    <div className="brand-spinner">
      <Lottie
        autoPlay
        type={
          application === Application.TTP
            ? LottieTypes.TtpSpinner
            : LottieTypes.FiversSpinner
        }
      />
    </div>
  );
};
